import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {formattedPrice} from "../helpers/MainHelper";

class PartsDetailTab extends React.Component {
  state = {
    activeTab: 1,
  }
  onTabChange = (tabIndex) => {
    this.setState({ activeTab: tabIndex });
  };
  render() {
    const {bodyData} = this.props;
    console.log('bodyData:'+bodyData)
    bodyData && bodyData.map((result, index) => (
        result.partItems.map((item, itemIndex) => (
                console.log(item)
            )
        )));
    const { activeTab } = this.state;
    return (
      <div className="col-lg-12">
        <div className="card">
          <div className="header">
            <h2>
              Parça Maliyetleri
              <small>
                Araç parçalarının ortalama maliyet bilgileri
              </small>
            </h2>
          </div>
          <div className="body">
            <ul className="nav nav-tabs" role="tablist">
              {bodyData && bodyData.map((part, index) => (
                  <li
                      key={index}
                      className={`nav-item mr-1 ${activeTab === index + 1 ? "active" : ""}`}
                      role="presentation"
                      onClick={() => this.onTabChange(index + 1)}
                  >
                    <Link to="#" className={`nav-link ${activeTab === index + 1 ? "active" : ""}`}>
                      {part.name}
                    </Link>
                  </li>
              ))}
            </ul>
            <div className="tab-content">
              {Object.keys(bodyData).length > 0 ? (
                  bodyData && bodyData.map((result, index) => (
                      <div
                          key={`content-${index}`}
                          className={`tab-pane ${activeTab === index + 1 ? "show active" : ""}`}
                      >
                        <p><strong>Sorgulanan ürün sayısı : </strong>{result.count} - <strong>Ortalama Fiyat : </strong> {formattedPrice(result.averagePrice)}</p>
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="row">
                              {result.partItems.map((item, itemIndex) => (
                                  <div className="col-lg-3 col-md-6" key={`item-${itemIndex}`}>
                                    <div className="card product_item">
                                      <div className="body">
                                        <div className="cp_img">
                                          <img alt="Product" className="img-fluid" src={item.image}/>
                                          <div className="hover">
                                            <a className="btn btn-primary mr-1" target="_blank"
                                               rel="noopener noreferrer" href={item.link}>
                                              <i className="icon-eye"></i>
                                            </a>
                                          </div>
                                        </div>
                                        <div className="product_details">
                                        <h5>
                                            <a href={item.link} target="_blank" rel="noopener noreferrer">{item.name}</a>
                                          </h5>
                                          <ul className="product_price list-unstyled">
                                            <li className="new_price">{item.price}</li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                  ))
              ) : (
                  <p>Ürün bulunamadı.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({});

export default connect(mapStateToProps, {})(PartsDetailTab);
